import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { appConfig } from '../../../core/core-config';
import { SOTService } from '../../services';

@Component({
  selector: "sot-initpage",
  templateUrl: "./initpage.component.html",
  styleUrls: ["./initpage.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InitpageComponent implements OnInit, OnDestroy {

  private _initalisationStatusChangedUbscription: Subscription;

  public version: string = "";

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService) {
    console.debug("--- sot-initpage constructor")
  }

  public ngOnInit(): void {
    console.debug("--- sot-initpage ngOnInit")
    const me = this;
    me._initalisationStatusChangedUbscription = me._sotService.evInitalisationStatusChanged.subscribe(() => { me.PushChanges(); });
    me.version = appConfig.version;
    me.PushChanges();
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-initpage ngOnDestroy")
    const me = this;
    if (me._initalisationStatusChangedUbscription) {
      this._initalisationStatusChangedUbscription.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      console.error("InitpageComponent.PushChanges > _changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public get initalisation_status(): string {
    return this._sotService.initalisation_status;
  }
}

